import { dataSourceColumns } from 'constants/InsightsGatheringConstants'

export const DataSources = () => (
  <div className="flex flex-col gap-10 items-center w-full">
    <p className="text-[28px] font-extrabold text-center">Example Data Sources for Each Part of the BVA</p>
    <div className="flex gap-4 items-stretch w-full h-full">
      {dataSourceColumns.map(column => (
        <div key={column.key} className="data-source-card flex flex-col gap-4">
          <p className="subtitle-xl">{column.title}</p>
          {column.categories.map(category => (
            <div key={category.label} className="flex flex-col gap-2">
              <p className="subtitle-xs">{category.label}</p>
              <ul className="insights-bullets body-xs">
                {category.bullets.map(bullet => (
                  <li key={bullet}>{bullet}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      ))}
    </div>
  </div>
)
